import MainButton from '../../shared/MainButton/MainButton';
import Typography, { FONT_TYPES } from '../../shared/Typography/Typography';

import buildVisitUrl from '../../../../utils/buildVisitUrl';

import styles from './ShortFinal.module.scss';

const ShortFinal = ({ texts }) => {
  const handleVisitClick = () => {
    window.location.href = buildVisitUrl(window.location.search);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <div className={styles.card}>
          <div className={styles.texts}>
            <Typography type={FONT_TYPES.h1} className={styles.title} isCenter>
              {texts.shortFinal.title}
            </Typography>
            <Typography
              type={FONT_TYPES.body_regular}
              htmlTag="p"
              className={styles.subtitle}
              isCenter
            >
              {texts.shortFinal.subtitle}
            </Typography>
          </div>
          <MainButton onClick={handleVisitClick}>{texts.shortFinal.cta}</MainButton>
        </div>
      </div>
    </div>
  );
};

export default ShortFinal;
